import { useEffect, useReducer } from 'react';

interface WindowSizeState {
  height: number;
  width: number;
}

const reducer = (state: WindowSizeState, nextState: WindowSizeState) => {
  if (state.height !== nextState.height || state.width !== nextState.width) {
    return nextState;
  }
  return state;
};

function useWindowSize(): [number, number] {
  const [size, setSize] = useReducer(reducer, undefined, () =>
    typeof window === 'undefined'
      ? {
          height: 0,
          width: 0,
        }
      : {
          height: window.innerHeight,
          width: window.innerWidth,
        }
  );

  useEffect(() => {
    const handler = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener('resize', handler);
    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [setSize]);

  return [size.width, size.height];
}

export default useWindowSize;
